<template>
    <v-expansion-panels>
        <v-expansion-panel v-for="(group, i) in groupedVideos" :key="i">
            <v-card-item>
                <div>
                    <h2>{{ group.达人昵称 }}</h2>
                </div>
                <div>{{ group.video_name }}</div>
                <div>{{ formatDate(group.shooting_time) }}</div>
            </v-card-item>
            <div>
                <v-list>
                    <v-container>
                        <v-row>
                            <v-col v-for="(video, j) in group.videos" :key="j">
                                <v-card variant="outlined" style="min-width: 150px;">
                                    <v-card-item>
                                        <v-card-subtitle v-if="video.commodity_name">{{ video.commodity_name }}
                                            <v-tooltip activator="parent" location="top">{{ video.commodity_name
                                                }}</v-tooltip>
                                        </v-card-subtitle>
                                        <v-card-text v-if="video.abstract">{{ video.abstract }}
                                            <v-tooltip activator="parent" location="top">{{ video.abstract
                                                }}</v-tooltip>
                                        </v-card-text>
                                        <v-card-subtitle>{{ formatDate(video.shooting_time) }}</v-card-subtitle>
                                        <v-card-text v-if="video.matched_text_context">
                                            <span v-html=video.matched_text_context></span>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn color="primary" @click="selectVideo(video)"
                                                class="align-center">剪辑</v-btn>
                                        </v-card-actions>
                                    </v-card-item>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-list>
            </div>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<script setup>
import { ref, onMounted, computed, defineProps } from 'vue'
import {useRouter} from 'vue-router'

const router = useRouter()

// 定义方法
const formatDate = (date) => {
  return new Date(date).toLocaleString('zh-CN');
};

// 定义props
const props = defineProps({
    videos: Array
})

const groupedVideos = computed(() => {
    const group = {}
    props.videos
        .forEach(video => {
            if (!group[video.source_id]) {
                group[video.source_id] = {                    
                    videos: []
                }
            }
            group[video.source_id].videos.push(video)
        })

    // 对group内的videos进行排序，根据先以shooting_time字段，从小到大排序，再以trans_time字段，从小到大排序
    for (const key in group) {
      group[key].videos.sort((a, b) => {
        var dateA = new Date(a.shooting_time), dateB = new Date(b.shooting_time);
        if(dateA - dateB === 0) {
          // 如果shooting_time相等，就比较trans_time
          return new Date(a.trans_time) - new Date(b.trans_time);
        } else {
          return dateA - dateB;
        }
      });
    }

      

    //对group内部的添加以下几个属性，都取videos列表的第一个：
    // video_name: video.video_name,
    // '达人昵称': video['达人昵称'],
    // 'shooting_time': video.shooting_time,
    for (const key in group) {
      group[key].video_name = group[key].videos[0].video_name
      group[key]['达人昵称'] = group[key].videos[0]['达人昵称']
      group[key]['shooting_time'] = group[key].videos.reduce((min, video) => video.shooting_time < min.shooting_time ? video : min, group[key].videos[0]).shooting_time;

    }      

    return group
  })



 // 点选事件，修改store中的currentVideo；告诉父组件，已经选择了视频，可以切换到下一个组件了
//  const selectVideo = (video) => {
//     //从store中获取当前视频
//     // const currentVideo = store.state.currentVideo
//     // if(currentVideo===video){
//     //   // do nothing
//     // }else{
//     //   store.commit('setSelectedVideo', video)
//     //   store.commit('setSelectedTextSpan', [])
//     // }
//     // store.commit('setSearchKeywords', search.value)      
//     console.log('video', video)
//     // useStore().commit('setCurrentVideo', video)
//     // useStore().commit('setCurrentTextSpan', [])
//     sessionStorage.setItem('currentVideo', JSON.stringify(video))
//     sessionStorage.setItem('currentTextSpan', JSON.stringify([]))
    
    
//     router.push('para')
//  }

const selectVideo = (video) => {
    // 其他代码保持不变
    console.log('video', video);
    sessionStorage.setItem('currentVideo', JSON.stringify(video));
    sessionStorage.setItem('currentTextSpan', JSON.stringify([]));

    // 使用绝对路径跳转，确保在任何页面（如搜索页）都能正确跳转到剪辑页
    // router.push('/clipper/kol/para');

    // 使用router.resolve获取目标路由的完整URL，并附加查询参数
    const baseHref = router.resolve('/clipper/kol/para').href;
    const hrefWithParam = `${baseHref}?tid=${video.transcription_id}`;

    // 创建一个新的<a>元素，设置href和target，然后模拟点击
    const link = document.createElement('a');
    link.href = hrefWithParam;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}


</script>


<style scoped>
/* 在这里添加你需要的样式 */
</style>